// Ref: https://docs.atomicvest.com/reference/usermanagerservice_createuser (occupation.industry)
export const EMPLOYMENT_INDUSTRY_MAP = {
    ACCOUNTING: 'Accounting',
    ADVERTISING__MARKETING: 'Advertising / Marketing',
    AEROSPACE__DEFENSE: 'Aerospace / Defense',
    AGRICULTURE__FORESTRY: 'Agriculture / Forestry',
    AMUSEMENT_AND_RECREATION: 'Amusement and Recreation',
    ANIMAL_SERVICES_AND_VETERINARY: 'Animal Services and Veterinary',
    ARCHITECTURE__DESIGN: 'Architecture / Design',
    ARTS__ANTIQUES: 'Arts / Antiques',
    ATHLETICS__FITNESS: 'Athletics / Fitness',
    AUTOMOTIVE: 'Automotive',
    AVIATION: 'Aviation',
    CHILDCARE: 'Childcare',
    CLEANING__JANITORIAL__HOUSEKEEPING: 'Cleaning / Janitorial / Housekeeping',
    COMMUNICATIONS__TELECOMMUNICATIONS: 'Communications / Telecommunications',
    CONSTRUCTION__CARPENTRY__LANDSCAPING:
        'Construction / Carpentry / Landscaping',
    CONVENIENCE_STORE__LIQUOR_STORE__GAS_STATION:
        'Convenience Store / Liquor Store / Gas Station',
    CUSTOMER_SERVICE_AND_SUPPORT: 'Customer Service and Support',
    EDUCATION: 'Education',
    EMBASSY__CONSULATE: 'Embassy / Consulate',
    ENERGY: 'Energy',
    ENGINEERING: 'Engineering',
    FASHION__CLOTHING: 'Fashion / Clothing',
    FINANCIAL_SERVICES: 'Financial Services',
    FIREARMS_AND_EXPLOSIVES: 'Firearms and Explosives',
    GAMING__CASINO__CARD_CLUB: 'Gaming / Casino / Card Club',
    GOVERNMENT__PUBLIC_ADMINISTRATION: 'Government / Public Administration',
    GROCERY__SUPERMARKET: 'Grocery / Supermarket',
    HEALTHCARE__MEDICAL_SERVICES: 'Healthcare / Medical Services',
    HOTEL__HOSPITALITY: 'Hotel / Hospitality',
    IMPORT__EXPORT: 'Import / Export',
    INFORMATION_TECHNOLOGY: 'Information Technology',
    INSURANCE: 'Insurance',
    JEWELRY_GEMS_AND_PRECIOUS_METALS: 'Jewelry Gems and Precious Metals',
    LEGAL_SERVICES__PUBLIC_SAFETY: 'Legal Services / Public Safety',
    LOGISTICS__SUPPLY_CHAIN: 'Logistics / Supply Chain',
    MANUFACTURING: 'Manufacturing',
    MARITIME: 'Maritime',
    MEDIA__ENTERTAINMENT: 'Media / Entertainment',
    MINING_OIL_AND_GAS: 'Mining Oil and Gas',
    MONEY_SERVICES_BUSINESSES: 'Money Services Businesses',
    NON_PROFIT__NGO__CHARITY: 'Non Profit / NGO / Charity',
    PARKING_AND_CAR_WASHES: 'Parking and Car Washes',
    PAWN_SHOPS__BROKERS: 'Pawn Shops / Brokers',
    PERSONAL_CARE__HYGIENE: 'Personal Care / Hygiene',
    PHARMACEUTICALS: 'Pharmaceuticals',
    PRINTING__PUBLISHING: 'Printing / Publishing',
    PROFESSIONAL__CIVIC_ORGANIZATIONS: 'Professional / Civic Organizations',
    REAL_ESTATE: 'Real Estate',
    RELIGIOUS_ORGANIZATION: 'Religious Organization',
    REPAIR_SERVICES: 'Repair Services',
    RESTAURANT__FOOD_SERVICE: 'Restaurant / Food Service',
    RETAIL_SALES__RETAIL_TRADE: 'Retail Sales / Retail Trade',
    RETIREMENT: 'Retirement',
    SCIENCE_AND_BIOTECHNOLOGY: 'Science and Biotechnology',
    SECURITY: 'Security',
    TRANSPORTATION: 'Transportation',
    TRAVEL: 'Travel',
    UTILITIES: 'Utilities',
    WHOLESALE_SALES__TRADE: 'Wholesale Sales / Trade',
    BAR__NIGHTCLUB__ADULT_ENTERTAINMENT_CLUB:
        'Bar / Nightclub / Adult Entertainment Club',
    INDUSTRY__NOT__APPLICABLE__UNEMPLOYED:
        'Industry Not Applicable / Unemployed',
    OTHER_INDUSTRY: 'Other Industry',
} as const;

// Ref: https://docs.atomicvest.com/reference/usermanagerservice_createuser (occupation.title)
export const EMPLOYMENT_ROLE_MAP_ATOMIC = {
    ACCOUNTANT__AUDITOR__BOOKKEEPER: 'Accountant / Auditor / Bookkeeper',
    ADJUSTER: 'Adjuster',
    ADVERTISER__MARKETER__PR_PROFESSIONAL:
        'Advertiser / Marketer / PR Professional',
    AIR_TRAFFIC_CONTROLLER: 'Air Traffic Controller',
    AMBASSADOR__CONSULATE_PROFESSIONAL: 'Ambassador / Consulate Professional',
    ANALYST: 'Analyst',
    APPRAISER: 'Appraiser',
    ARCHITECT__DESIGNER: 'Architect / Designer',
    ARTIST__PERFORMER__ACTOR__DANCER: 'Artist / Performer / Actor / Dancer',
    ASSISTANT__EXECUTIVE_ASSISTANT: 'Assistant / Executive Assistant',
    ATHLETE: 'Athlete',
    ATTORNEY__JUDGE__LEGAL_PROFESSIONAL:
        'Attorney / Judge / Legal Professional',
    AUCTIONEER: 'Auctioneer',
    BANKER__LENDING_PROFESSIONAL: 'Banker / Lending Professional',
    BARBER__BEAUTICIAN__HAIRSTYLIST: 'Barber / Beautician / Hairstylist',
    BROKER__REGISTERED_REP: 'Broker / Registered Rep',
    BUSINESS_EXECUTIVE: 'Business Executive',
    BUSINESS_OWNER: 'Business Owner',
    CAREGIVER: 'Caregiver',
    CARPENTER__CONSTRUCTION_WORKER__CONTRACTOR:
        'Carpenter / Construction Worker / Contractor',
    CASHIER: 'Cashier',
    CHEF__COOK: 'Chef / Cook',
    CHIROPRACTOR: 'Chiropractor',
    CIVIL_SERVANT: 'Civil Servant',
    CLERGY: 'Clergy',
    CLERK: 'Clerk',
    COMPLIANCE__REGULATORY_PROFESSIONAL: 'Compliance / Regulatory Professional',
    CONSULTANT: 'Consultant',
    COUNSELOR__THERAPIST: 'Counselor / Therapist',
    CUSTOMER_SERVICE_REPRESENTATIVE: 'Customer Service Representative',
    DEALER: 'Dealer',
    DENTIST: 'Dentist',
    DISTRIBUTOR: 'Distributor',
    DOCTOR__SURGEON__PHYSICIAN: 'Doctor / Surgeon / Physician',
    DRIVER: 'Driver',
    ENGINEER: 'Engineer',
    EXTERMINATOR: 'Exterminator',
    EXECUTIVE: 'Executive',
    FACTORY__WAREHOUSE_WORKER: 'Factory / Warehouse Worker',
    FARMER__RANCHER: 'Farmer / Rancher',
    FINANCIAL_PLANNER__ADVISOR: 'Financial Planner / Advisor',
    FLIGHT_ATTENDANT: 'Flight Attendant',
    HUMAN_RESOURCES_PROFESSIONAL: 'Human Resources Professional',
    IMPORTER__EXPORTER: 'Importer / Exporter',
    INSPECTOR__INVESTIGATOR: 'Inspector / Investigator',
    INVESTOR: 'Investor',
    IT_PROFESSIONAL__IT_ASSOCIATE: 'IT Professional / IT Associate',
    JANITOR: 'Janitor',
    JEWELER: 'Jeweler',
    LABORER: 'Laborer',
    LANDSCAPER: 'Landscaper',
    MECHANIC: 'Mechanic',
    MILITARY_OFFICER_OR_ASSOCIATED: 'Military Officer or Associated',
    MORTICIAN__FUNERAL_DIRECTOR: 'Mortician / Funeral Director',
    NURSE: 'Nurse',
    OFFICE_ASSOCIATE: 'Office Associate',
    PHARMACIST: 'Pharmacist',
    PHYSICAL_THERAPIST: 'Physical Therapist',
    PILOT: 'Pilot',
    POLICE_OFFICER__FIREFIGHTER__LAW_ENFORCEMENT_PROFESSIONAL:
        'Police Officer / Firefighter / Law Enforcement Professional',
    POLITICIAN: 'Politician',
    PROJECT_MANAGER: 'Project Manager',
    REAL_ESTATE_PROFESSIONAL: 'Real Estate Professional',
    RESEARCHER: 'Researcher',
    SALESPERSON: 'Salesperson',
    SCIENTIST: 'Scientist',
    SEAMSTRESS__TAILOR: 'Seamstress / Tailor',
    SECURITY_GUARD: 'Security Guard',
    SOCIAL_WORKER: 'Social Worker',
    TEACHER__PROFESSOR: 'Teacher / Professor',
    TECHNICIAN: 'Technician',
    TELLER: 'Teller',
    TRADESPERSON__CRAFTSPERSON: 'Tradesperson / Craftsperson',
    TRAINER__INSTRUCTOR: 'Trainer / Instructor',
    UNDERWRITER: 'Underwriter',
    VETERINARIAN: 'Veterinarian',
    WRITER__JOURNALIST__EDITOR: 'Writer / Journalist / Editor',
    TITLE__NOT__APPLICABLE__UNEMPLOYED: 'Title Not Applicable / Unemployed',
} as const;

export const EMPLOYMENT_ROLE_MAP_ADDITIONS = {
    PRODUCT_MANAGER: 'Product Manager', // added by Plenty - not in Atomic's list
    SOFTWARE_ENGINEER: 'Software Engineer', // added by Plenty - not in Atomic's list
} as const;

export const EMPLOYMENT_ROLE_MAP = {
    ...EMPLOYMENT_ROLE_MAP_ATOMIC,
    ...EMPLOYMENT_ROLE_MAP_ADDITIONS,
} as const;

export type EmploymentRole = keyof typeof EMPLOYMENT_ROLE_MAP;
export type EmploymentRoleAtomic = keyof typeof EMPLOYMENT_ROLE_MAP_ATOMIC;
export type EmploymentRoleAddition = keyof typeof EMPLOYMENT_ROLE_MAP_ADDITIONS;

const EMPLOYMENT_ROLE_ADDITIONS_TO_ATOMIC_EMPLOYMENT_ROLE_MAP: Record<
    EmploymentRoleAddition,
    EmploymentRoleAtomic
> = {
    PRODUCT_MANAGER: 'PROJECT_MANAGER',
    SOFTWARE_ENGINEER: 'IT_PROFESSIONAL__IT_ASSOCIATE',
} as const;

export const atomicEmploymentRoleFromEmploymentRole = (
    role: EmploymentRole
): EmploymentRoleAtomic => {
    if (isAddition(role)) {
        return EMPLOYMENT_ROLE_ADDITIONS_TO_ATOMIC_EMPLOYMENT_ROLE_MAP[role];
    }

    return role;
};

const isAddition = (k: EmploymentRole): k is EmploymentRoleAddition => {
    return k in EMPLOYMENT_ROLE_MAP_ADDITIONS;
};
